<template>
	<div class="myOrderContainer">
		<div class="msg-center-nav">
			<div class="msg-categories">
				<div v-for="category in categories" :key="category.key" class="category-item"
					:class="{ 'active': activeCategory === category.key }" @click="switchCategory(category.key)">
					{{ category.name }}
				</div>
			</div>
		</div>
		<div class="orderListBox">
			<div class="orderMenu">
				<div class="menuItem">订单信息</div>
				<div class="menuItem">商品金额</div>
				<div class="menuItem">实付款</div>
				<div class="menuItem">订单操作</div>
			</div>
			<div class="checkDownload">
				<div class="check" v-if="!checkAll && (activeCategory == 0 || activeCategory == 2)"
					@click="changeAllWork(true)">全选</div>
				<div class="check" v-if="checkAll" @click="changeAllWork(false)">取消全选</div>
				<div class="download" v-if="checkAll" @click="downloadAll">
					<img class="icon" src="../assets/MyOrder/iconC.png" />
					一键下载
				</div>
			</div>
			<div class="orderList" v-if="orderData.length">
				<div class="orderItem" v-for="(item,index) in orderData" :key="index">
					<div class="orderItemTop">
						<div class="timeNoDetails">
							<div class="time">{{item.create_time}}</div>
							<div class="no">订单号: {{item.order_sn}}</div>
							<div class="details" @click="naviToDetails(item)">订单详情<img class="arrow"
									src="../assets/MyOrder/iconD.png" />
							</div>
						</div>
						<div class="countdownStatus">
							<countdown :end-time="item.del_time * 1000" @finish="onCountdownFinish"
								v-if="item.pay_status == 0 && item.status != 4">
								<template slot="process" slot-scope="{ timeObj }">
									<div class="countdown">
										<div>{{timeObj.h}}</div>:
										<div>{{timeObj.m}}</div>:
										<div>{{timeObj.s}}</div>后取消订单
									</div>
								</template>
							</countdown>
							<div class="status">{{getStatusName(item)}}</div>
						</div>
					</div>
					<div class="orderItemBottom">
						<div class="checkImgGoodsInfoBox">
							<img class="checkImg" src="../assets/Register/checkSel.png"
								v-if="checkAll && item.check && item.pay_status == 1 && item.status == 3"
								@click="item.check = false" />
							<img class="checkImg" src="../assets/Register/checkNor.png"
								v-if="checkAll && !item.check && item.pay_status == 1 && item.status == 3"
								@click="item.check = true && item.pay_status == 1 && item.status == 3" />
							<img class="checkImg" src="../assets/Register/checkDisable.png"
								v-if="checkAll && (item.pay_status == 0 || item.pay_status == 1 && item.status != 3)" />
							<div class="goodsInfoBox">
								<img class="goodsImg" :src="item.goods_img" />
								<div class="goodsInfo">
									<div class="goodsTitle ellipsis-1">{{item.goods_name}}</div>
									<div class="goodsDesc ellipsis-2">{{item.goods_content}}</div>
									<div class="tips">
										<div class="tip" v-if="item.cid">{{item.cid}}</div>
										<div class="tip" v-for="(row,rowIndex) in item.yongtu.slice(0,1)"
											:key="rowIndex">{{row}}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="goodsPrice">
							¥{{item.original_price}}
						</div>
						<div class="costPrice">
							¥{{item.pay_price}}
							<div class="coupon">
								优惠券：-¥{{item.coupon_price}}
							</div>
						</div>
						<div class="operation">
							<div class="download" v-if="item.pay_status == 1 && item.status == 3"
								@click="downloadImages(item.yt_img)">下载图片</div>
							<div class="apply" v-if="item.pay_status == 1 && item.status == 3 && item.invoice == 0"
								@click="applyInvoice(item)">
								<img src="../assets/MyOrder/iconB.png">
								申请发票
							</div>
							<div class="payNow" v-if="item.pay_status == 0 && item.status != 4" @click="payOrder(item)">
								立即支付</div>
							<div class="cancel" v-if="item.pay_status == 0 && item.status != 4"
								@click="cancelOrder(item)">取消订单</div>
							<div class="delete" v-if="item.pay_status == 0 && item.status == 4"
								@click="deleteOrder(item)">删除</div>
						</div>
					</div>
				</div>
			</div>
			<el-empty description="暂无数据" v-else></el-empty>
		</div>
		<div v-if="showProgress" style="margin-top: 20px; width: 400px;">
			<el-progress :percentage="progress"></el-progress>
		</div>
		<PagePagination v-if="orderData.length" style="padding: .32rem 0 0rem;" :currentPage="currentPage"
			:total="total" @current-change="onPageChange" />
		<ApplyInvoiceDialog :show="dialogApplyInvoiceViable" :type="1" :orderData="curOrder"
			@close="dialogApplyInvoiceViable = false" @update="sucPop = true;normalOrder()" />
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'提交成功'" @clickOk="sucPop = false"
			v-if="sucPop" />
		<PopToast :imgPtahUrl="require('@/assets/Register/exclaim.png')" :desc="'很遗憾，您选择的作品已售罄'"
			@clickOk="tipPop = false;normalOrder()" v-if="tipPop" />
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'购买成功！'" :subTitle="'请到个人中心我的订单中查看！'"
			@clickOk="paySucPop = false" v-if="paySucPop" />
		<PayDialog :show="dialogPayViable" :orderType="1" :payUrl="payUrl" :orderId="curOrder.id"
			@close="dialogPayViable = false" @success="paySucPop = true;normalOrder()" />
	</div>
</template>

<script>
	import JSZip from "jszip";
	import {
		saveAs
	} from "file-saver";
	import PopToast from '../components/PopToast.vue'
	import PayDialog from '../../src/components/PayDialog.vue'
	import ApplyInvoiceDialog from '../../src/components/ApplyInvoiceDialog.vue'
	export default {
		components: {
			ApplyInvoiceDialog,
			PayDialog,
			PopToast
		},
		data() {
			return {
				imgList: [],
				concurrency: 5, // 并发下载数量
				maxZipSize: 500 * 1024 * 1024, // 500MB 分卷
				progress: 0, // 总进度百分比
				showProgress: false,
				payUrl: '',
				tipPop: false,
				sucPop: false,
				checkAll: false,
				paySucPop: false,
				dialogPayViable: false,
				dialogApplyInvoiceViable: false,
				// 分类导航
				categories: [{
						key: '0',
						name: '全部'
					},
					{
						key: '1',
						name: '待支付'
					},
					{
						key: '2',
						name: '已完成'
					},
					{
						key: '3',
						name: '已取消'
					}
				],
				curOrder: {},
				orderData: [],
				currentPage: 1,
				total: 0,
				activeCategory: '0',
				deadline4: Date.now() + (new Date().setHours(23, 59, 59) - Date.now()),
			}
		},
		mounted() {
			this.normalOrder()
		},
		methods: {
			async downloadZip() {
				this.showProgress = true;
				this.progress = 0;

				const loading = this.$loading({
					lock: true,
					text: "准备中...",
					spinner: "el-icon-loading",
					background: "rgba(0,0,0,0.7)"
				});

				// 分卷 zip 列表
				let zipIndex = 1;
				let currentZip = new JSZip();
				let currentFolder = currentZip.folder("images");
				let currentZipSize = 0; // 当前 zip 大小累计

				let completed = 0;

				try {
					// --------------------------
					// 并发控制器
					// --------------------------
					const parallel = async (list, limit, iteratorFn) => {
						const ret = [];
						const executing = [];
						for (const item of list) {
							const p = Promise.resolve().then(() => iteratorFn(item));
							ret.push(p);

							if (executing.length >= limit) {
								await Promise.race(executing);
							}

							const e = p.then(() =>
								executing.splice(executing.indexOf(e), 1)
							);
							executing.push(e);
						}
						return Promise.all(ret);
					};

					// --------------------------
					// 自动重试（3 次）
					// --------------------------
					const fetchWithRetry = async (url, retry = 3) => {
						for (let i = 0; i < retry; i++) {
							try {
								const res = await fetch(url);
								if (!res.ok) throw new Error("fetch失败");
								return await res.blob();
							} catch (e) {
								console.warn(`❌ 图片下载失败，重试 ${i + 1} 次：${url}`);
							}
						}
						throw new Error("三次失败");
					};

					// --------------------------
					// 下载图片逻辑
					// --------------------------
					const downloadImage = async (url) => {
						const index = this.imgList.indexOf(url);
						loading.text = `下载中 ${index + 1}/${this.imgList.length} ...`;

						try {
							const blob = await fetchWithRetry(url);

							// 自动识别扩展名
							let ext = url.split(".").pop().split("?")[0];
							if (!ext || ext.length > 5) ext = "jpg"; // fallback

							const filename = url.split("/").pop().split("?")[0];
							const file = new File([blob], filename, {
								type: blob.type
							});
							console.log(file)
							// 分卷判断：当前 zip 大小达到 500MB → 自动另起一个 ZIP
							currentZipSize += blob.size;

							if (currentZipSize > this.maxZipSize) {
								await this.saveZip(currentZip, zipIndex);
								zipIndex++;

								currentZip = new JSZip();
								currentFolder = currentZip.folder("images");
								currentZipSize = 0;
							}

							// 添加文件到 ZIP
							currentFolder.file(filename, blob);

						} catch (e) {
							console.warn("图片多次失败，自动跳过：", url);
						}

						completed++;
						this.progress = Math.floor((completed / this.imgList.length) * 100);
					};

					// --------------------------
					// 执行下载并限制并发
					// --------------------------
					await parallel(this.imgList, this.concurrency, downloadImage);

					// 保存最后一个 zip
					await this.saveZip(currentZip, zipIndex);

				} catch (e) {
					this.$message.error("下载失败：" + e.message);
				} finally {
					loading.close();
					this.showProgress = false;
				}
			},

			// --------------------------
			// 保存 ZIP 为文件
			// --------------------------
			async saveZip(zip, index) {
				const blob = await zip.generateAsync({
						type: "blob"
					},
					(progress) => {
						this.progress = Math.floor(progress.percent);
					}
				);

				saveAs(blob, `images-part-${index}.zip`);
			},
			downloadAll() {
				const imgages = this.orderData.filter(v => v.check == true && v.pay_status == 1 && v.status == 3 && v
					.yt_img).map(v => v.yt_img);
				this.downloadImages([].concat(...imgages))
			},
			getFileNameFromUrl(url) {
				// 从 URL 中提取文件名
				return url.substring(url.lastIndexOf('/') + 1);
			},
			downloadImages(imageList) {
				this.imgList = imageList
				this.downloadZip()
			},
			onCountdownFinish() {
				console.log("倒计时结束啦！");
			},
			changeAllWork(isAll) {
				this.checkAll = isAll
				this.orderData.map(item => item.check = true)
			},
			onPageChange(newPage) {
				this.currentPage = newPage
				this.normalOrder()
			},
			getStatusName(item) {
				if (item.pay_status == 0) {
					if (item.status == 4) {
						return '已取消'
					} else {
						return '待支付'
					}
				} else {
					if (item.out_refund_no) {
						return '已退款'
					} else {
						if (item.status == 3) {
							return '已完成'
						}
					}
				}
			},
			naviToDetails(item) {
				this.$router.push({
					path: '/order-details',
					query: {
						type: 1,
						orderId: item.id
					}
				})
			},
			// 切换分类
			switchCategory(category) {
				this.activeCategory = category;
				this.checkAll = false
				this.normalOrder()
			},
			normalOrder() {
				this.orderData = []
				this.$api.post('/Hua/hua_order_list', {
					type: this.activeCategory,
					sf_type: 1,
				}).then(res => {
					if (res.code == 1) {
						res.data.list.forEach(item => {
							this.orderData.push({
								...item,
								check: true
							})
						})
						this.total = res.data.count
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//取消订单
			cancelOrder(item) {
				this.$confirm('确认取消当前订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/Hua/hua_order_cancel', {
						id: item.id,
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.normalOrder()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});
			},
			//删除订单
			deleteOrder(item) {
				this.$confirm('确认删除当前订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/Hua/hua_order_del', {
						id: item.id,
						type: 1,
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.normalOrder()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});
			},
			payOrder(item) {
				this.$api.post('/Tonglian/nativepay', {
					id: item.id,
				}).then(res => {
					if (res.code == 1) {
						this.curOrder = item
						this.payUrl = res.data
						this.dialogPayViable = true
					} else {
						if (res.msg == '作品已售馨') {
							this.tipPop = true
						} else {
							this.$message.error(res.msg)
						}
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//申请发票
			applyInvoice(item) {
				this.curOrder = item
				this.dialogApplyInvoiceViable = true
			}
		}
	}
</script>

<style lang="scss" scoped>
	.myOrderContainer {
		display: flex;
		flex-direction: column;
		padding: .24rem .4rem;
	}

	/* 消息分类导航样式 */
	.msg-center-nav {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: .01rem solid rgba(204, 204, 204, .4);
	}

	.msg-categories {
		display: flex;
		gap: .32rem;
	}

	.category-item {
		font-weight: 400;
		font-size: .16rem;
		color: #040404;
		cursor: pointer;
		padding: .24rem 0 .15rem;
		position: relative;
		transition: color 0.3s ease;
	}

	.category-item:hover {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item.active {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: .02rem;
		background-color: #693200;
		transform: scaleX(0);
		transform-origin: left center;
		transition: transform 0.3s ease;
	}

	.category-item.active::after {
		transform: scaleX(1);
	}

	.orderListBox {
		display: flex;
		flex-direction: column;

		.orderMenu {
			display: flex;
			align-items: center;

			.menuItem {
				height: .5rem;
				font-weight: 400;
				font-size: .14rem;
				color: #666666;
				text-align: center;
				line-height: .5rem;
			}

			.menuItem:nth-child(1) {
				width: 4rem;
			}

			.menuItem:nth-child(2) {
				width: 1.6rem;
			}

			.menuItem:nth-child(3) {
				width: 1.95rem;
			}

			.menuItem:nth-child(4) {
				width: 1.2rem;
			}
		}

		.checkDownload {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 .16rem;

			.check {
				font-weight: 400;
				font-size: .14rem;
				color: #666666;
				cursor: pointer;
			}

			.download {
				display: flex;
				align-items: center;
				font-weight: 400;
				font-size: .14rem;
				color: #A88653;
				cursor: pointer;

				.icon {
					margin-right: .04rem;
					width: .14rem;
					height: .14rem;
				}
			}
		}

		.orderList {
			margin-top: .1rem;
			display: flex;
			flex-direction: column;

			.orderItem {
				display: flex;
				flex-direction: column;

				.orderItemTop {
					height: .4rem;
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 0 .16rem;
					background: #FAEFDD;
					border-radius: .04rem;

					.timeNoDetails {
						display: flex;
						align-items: center;

						.time,
						.no {
							font-weight: 400;
							font-size: .14rem;
							color: #333333;
						}

						.no {
							margin-left: .16rem;
						}

						.details {
							margin-left: .16rem;
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .14rem;
							color: #A88653;
							cursor: pointer;

							.arrow {
								margin-left: .04rem;
								width: .05rem;
								height: .08rem;
							}
						}
					}

					.countdownStatus {
						display: flex;
						align-items: center;

						.countdown {
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .12rem;
							color: #252525;

							div {
								margin-left: .02rem;
								margin-right: .02rem;
								width: .22rem;
								height: .22rem;
								background: #E29358;
								border-radius: .04rem;
								line-height: .22rem;
								text-align: center;
								font-weight: 500;
								font-size: .12rem;
								color: #252525;
							}
						}

						.status {
							margin-left: .16rem;
							font-weight: 400;
							font-size: .14rem;
							color: #E29358;
						}
					}
				}

				.orderItemBottom {
					padding: .12rem 0 .24rem;
					display: flex;
					align-items: center;

					.checkImgGoodsInfoBox {
						width: 4rem;
						display: flex;
						align-items: center;

						.checkImg {
							width: .18rem;
							height: .18rem;
							cursor: pointer;
						}

						.goodsInfoBox {
							margin-left: .24rem;
							display: flex;
							align-items: center;

							.goodsImg {
								width: .76rem;
								height: 1.02rem;
								border-radius: .08rem;
								overflow: hidden;
								object-fit: cover;
							}

							.goodsInfo {
								width: 2.4rem;
								margin-left: .16rem;
								display: flex;
								flex-direction: column;

								.goodsTitle {
									font-weight: 700;
									font-size: .16rem;
									color: #000000;
									line-height: .22rem;
								}

								.goodsDesc {
									margin-top: .08rem;
									font-weight: 400;
									font-size: .12rem;
									color: #333333;
									line-height: .16rem;
								}

								.tips {
									margin-top: .12rem;
									display: flex;
									align-items: center;

									.tip {
										margin-right: .1rem;
										height: .26rem;
										padding: 0 .08rem;
										border-radius: .13rem;
										border: .01rem solid #A88653;
										line-height: .24rem;
										font-weight: 400;
										font-size: .12rem;
										color: #7C3E0B;
									}
								}
							}
						}
					}


				}

				.goodsPrice {
					width: 1.6rem;
					font-weight: 400;
					font-size: .14rem;
					color: #000000;
					text-align: center;
				}

				.costPrice {
					width: 1.95rem;
					display: flex;
					flex-direction: column;
					align-items: center;
					font-weight: 400;
					font-size: .14rem;
					color: #000000;

					.coupon {
						margin-top: .04rem;
						font-size: .12rem;
						color: #999999;
					}
				}

				.operation {
					width: 1.2rem;
					display: flex;
					flex-direction: column;
					align-items: center;

					.download,
					.payNow {
						width: .88rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						line-height: .36rem;
						text-align: center;
						cursor: pointer;
					}

					.apply {
						margin-top: .12rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .12rem;
						color: #333333;
						cursor: pointer;

						img {
							margin-right: .04rem;
							width: .12rem;
							height: .12rem;
						}
					}

					.cancel {
						margin-top: .12rem;
						font-weight: 400;
						font-size: .12rem;
						color: #999999;
						cursor: pointer;
					}

					.delete {
						width: .88rem;
						height: .36rem;
						border-radius: .04rem;
						border: .01rem solid #E29358;
						font-weight: 400;
						font-size: .14rem;
						color: #E29358;
						line-height: .36rem;
						text-align: center;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>